<template>
  <div class="garden-help-register garden-help-auth-container h-100">
    <b-row class="w-100 h-100">
      <b-col lg="3" md="3" sm="3" class="garden-help-auth-bg-container garden-help-auth-border-radius position-fixed h-100 p-0">
      </b-col>
      <b-col lg="9" md="9" sm="9" class="form-wizard-register-container ">
        <b-row class="justify-content-center">
          <b-col cols="11">
            <p class="register-steps-info-garden-help mr-3">
              Step {{ tabIndex + 1 }} of {{ total_Steps }}
            </p>
            <b-progress :value="tabIndex + 1" :max="total_Steps" class="progress-garden-help mb-3"></b-progress>
          </b-col>
        </b-row>
        <b-form novalidate @submit.prevent="onSubmit" class="register-form" ref="contractorRegisterForm">
          <b-row class="mt-1">
            <b-col xl="7" lg="8" md="9" sm="11" class="m-auto p-0">

              <b-tabs v-model="tabIndex">
                <b-tab title="">
                  <ContractorDetails :type="type" :is_company.sync="is_company" :first_name.sync="first_name"
                    :invalid_first_name="invalid_first_name" :last_name.sync="last_name"
                    :invalid_last_name="invalid_last_name" :email.sync="email" :invalid_email="invalid_email"
                    :invalid_correct_email="invalid_correct_email" :phone_number.sync="phone_number"
                    :invalid_phone_number="invalid_phone_number" :password.sync="password"
                    :invalid_password="invalid_password" :invalid_correct_password="invalid_correct_password"
                    :confirm_password.sync="confirm_password" :invalid_confirm_password="invalid_confirm_password"
                    :invalid_correct_confirm_password="invalid_correct_confirm_password" :address.sync="address"
                    :longitude.sync="longitude" :latitude.sync="latitude" :invalid_address="invalid_address"
                    :invalid_address_longitude="invalid_address_longitude"
                    :invalid_address_latitude="invalid_address_latitude" :country.sync="country" :county.sync="county"
                    :city.sync="city" :currency.sync="currency" :country_code.sync="country_code"
                    :linkedin.sync="linkedin" :facebook.sync="facebook" :website.sync="website"
                    :experience_level.sync="experience_level" :invalid_experience_level="invalid_experience_level"
                    :service_options="service_options" :service.sync="service" :invalid_service="invalid_service"
                    :rate.sync="rate" :invalid_rate="invalid_rate" :rate_amount.sync="rate_amount"
                    :vat_number.sync="vat_number" :invalid_rate_amount="invalid_rate_amount"
                    :subscription.sync="subscription"
                  />
                </b-tab>
<!--                <b-tab title="" v-if="is_company == 1" lazy>-->
<!--                  <CompanyDetails :type="type" :is_company="is_company" :legal_company_name.sync="legal_company_name"-->
<!--                    :invalid_legal_company_name="invalid_legal_company_name"-->
<!--                    :company_trading_name.sync="company_trading_name" :primary_email_address.sync="primary_email_address"-->
<!--                    :invalid_primary_email_address="invalid_primary_email_address"-->
<!--                    :company_registration_number.sync="company_registration_number"-->
<!--                    :company_description.sync="company_description" :service_options="service_options"-->
<!--                    :service.sync="service" :invalid_service="invalid_service"-->
<!--                    :business_name="business_name"-->
<!--                  />-->
<!--                </b-tab>-->
                <!-- <b-tab title="" v-if="is_company == 1">
                  <AdminsRegistrations :type="type" :is_company="is_company" :add_admin.sync="add_admin"
                    :admins.sync="admins" />
                </b-tab> -->
<!--                <b-tab title="" v-if="is_company == 1" lazy>-->
<!--                  <StaffRegistrations :type="type" :is_company="is_company" :add_staff.sync="add_staff"-->
<!--                    :staff_list.sync="staff_list" :country="country" :country_code="country_code" />-->

<!--                  &lt;!&ndash; {{ staff_list }} &ndash;&gt;-->
<!--                </b-tab>-->
<!--                <b-tab title="">-->
<!--                  <FilesInputView :type="type" :is_company="is_company" :company_logo.sync="company_logo"-->
<!--                    :images.sync="images" :job_reference.sync="job_reference" :term_conditions.sync="term_conditions"-->
<!--                    :invalid_term_conditions="invalid_term_conditions" />-->

<!--                </b-tab>-->
                <!-- <b-tab title="">
                  <PaymentView />
                </b-tab> -->
              </b-tabs>
            </b-col>
          </b-row>
          <!-- {{ address }}, {{ longitude }},{{ latitude }},
          {{ country }}, {{ county }}, {{ city }} -->

          <b-row class="">
            <b-col xl="7" lg="8" md="9" sm="11" class="m-auto px-1">
              <b-button-group class="btn-group-form-steps-garden-help">
                <b-button :disabled="tabIndex === 0" type="button" variant="info-outline" class="back-btn"
                  @click="clickBack">Back</b-button>
                <b-button v-show="tabIndex + 1 < total_Steps" type="button" variant="primary" class="next-btn"
                  @click="clickNext">Continue</b-button>
                <b-button v-if="tabIndex + 1 == total_Steps && !is_loading" variant="primary" class="next-btn"
                  type="submit">Submit</b-button>
                <b-button v-else-if="tabIndex + 1 == total_Steps && is_loading" type="button" disabled variant="primary"
                  class="next-btn">
                  <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                  Loading
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-form>
        <!-- {{ staff_list }} -->
        <!-- {{job_reference}} -->
      </b-col>
    </b-row>
    <b-modal id="select-subscription-modal" modal-class="modal-garden-help modal-subscriptions"
      title-class="modal-title-garden-help" hide-footer scrollable>
      <template #modal-title>
        Subscriptions
        <span class="modal-subtitle-garden-help">
          Select your subscribtion to start bidding on jobs
        </span>
      </template>
      <SelectSubscription :subscription.sync="subscription" />
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
// import { FormWizard, TabContent } from "vue-form-wizard";
// import "vue-form-wizard/dist/vue-form-wizard.min.css";

import ContractorDetails from "./profile_details_components/ContractorDetails.vue";
import CompanyDetails from "./profile_details_components/CompanyDetails.vue";
import FilesInputView from "./profile_details_components/FilesInputView.vue";
import AdminsRegistrations from "./profile_details_components/AdminsRegistrations.vue";
import StaffRegistrations from "./profile_details_components/StaffRegistrations.vue";
import PaymentView from "./profile_details_components/PaymentView.vue";
import SelectSubscription from "@/components/subscriptions/SelectSubscription.vue";

import { uploadFiles } from "@/utils/upload-files.js";
import { validatePassword, validateEmail } from "@/utils/validate.js";

export default {
  name: "GardenHelpContractorRegister",
  components: {
    ContractorDetails,
    CompanyDetails,
    FilesInputView,
    AdminsRegistrations,
    StaffRegistrations,
    PaymentView,
    SelectSubscription,
  },
  data() {
    return {
      client_name: "GARDENHELP",
      total_Steps: 1,
      tabIndex: 0,

      type: "register",
      // contractor details
      first_name: "",
      invalid_first_name: false,
      last_name: "",
      invalid_last_name: false,
      email: "",
      invalid_email: false,
      invalid_correct_email: false,
      phone_number: "",
      invalid_phone_number: false,
      address: null,
      longitude: null,
      latitude: null,
      invalid_address: false,
      invalid_address_longitude: false,
      invalid_address_latitude: false,
      country: null,
      county: null,
      city: null,
      currency: null,
      country_code: null,
      // address: 'Iveson Approach, Leeds LS16 6FR, UK',
      // longitude: -1.6039033,
      // latitude: 53.8467409,
      // invalid_address: false,
      // invalid_address_longitude: false,
      // invalid_address_latitude: false,
      // country: 'United Kingdom',
      // county: 'England',
      // city: 'West Yorkshire',
      // currency: 'GBP',
      // country_code:'GB',

      /**

      formData.append("address", this.address);
      formData.append("longitude", this.longitude);
      formData.append("latitude", this.latitude);
      formData.append("country", this.country);
      formData.append("county", this.county);
      formData.append("city", this.city);
      formData.append("currency", this.currency);
      formData.append("country_code", this.country_code); */
      experience_level: "",
      invalid_experience_level: false,
      service_options: [
        // { label: "Grass Cutting", code: 1 },
        // { label: "Garden Maintenance", code: 2 },
        // { label: "Landscaping/Garden Design ", code: 3 },
        // { label: "Fencing", code: 4 },
      ],
      service: null,
      invalid_service: false,
      rate: null,
      invalid_rate: false,
      rate_amount: null,
      invalid_rate_amount: false,
      password: "",
      invalid_password: false,
      invalid_correct_password: false,
      confirm_password: "",
      invalid_confirm_password: false,
      invalid_correct_confirm_password: false,
      linkedin: "",
      facebook: "",
      website: "",
      subscription: "",
      is_company: 1,
      vat_number: "",
      // company details
      legal_company_name: "",
      invalid_legal_company_name: false,
      company_trading_name: "",
      primary_email_address: "",
      invalid_primary_email_address: false,
      company_registration_number: "",
      company_description: "",
      business_name: '',
      // files
      company_logo: [],
      company_logo_id: null,
      images: [],
      images_ids: null,
      job_reference: [],
      job_reference_ids: null,
      term_conditions: null,
      invalid_term_conditions: false,
      // add admins
      add_admin: null,
      admins: [
        {
          name: "",
          invalid_name: false,
          email: "",
          invalid_email: false,
          phone_number: "",
          invalid_phone_number: false,
        },
      ],
      invalid_admins: false,
      // add staff
      add_staff: null,
      staff_list: [
        {

          first_name: "",
          invalid_first_name: false,
          last_name: "",
          invalid_last_name: false,
          email: "",
          invalid_email: false,
          invalid_correct_email: false,
          phone: "",
          invalid_phone: false,
          experience_level: "",
          invalid_experience_level: false,
          services: null,
          invalid_services: false,

          address: null,
          longitude: null,
          latitude: null,
          invalid_address: false,
          invalid_address_longitude: false,
          invalid_address_latitude: false,
          country: null,
          county: null,
          city: null,
          country_code: null

        },
      ],
      invalid_staff: false,
      ////
      operator_id: null,
      swal_confirm_button_class:
        "btn btn-bumblebee btn-garden-help  btn-garden-help-primary",
      swal_container_class: "swal-container-garden-help",
      is_loading: false,
    };
  },
  updated() { },
  mounted() {
    axios
      .get("/services/list", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          client: this.client_name,
        },
      })
      .then((response) => {
        console.log(response);
        this.service_options = response.data;
      });
  },
  watch: {
    is_company(newval, oldval) {
      console.log("watch", newval, oldval);

      var temp = this;
      // setTimeout(function () {
      if (newval == 1) {
        // temp.total_Steps = 6;
        temp.total_Steps = 5;
      } else {
        temp.total_Steps = 3;
      }
      // }, 1000);
    },
    country(newval) {
      for (let i = 0; i < this.staff_list.length; i++) {
        this.staff_list[i].country = newval
      }
    },
    country_code(newval) {
      for (let i = 0; i < this.staff_list.length; i++) {
        this.staff_list[i].country_code = newval
      }
    }
    // email(){
    //   console.log("Emaail", this.email)
    //   console.log(this.validateEmail(this.email))
    // }
  },
  methods: {
    uploadFiles,
    validatePassword,
    validateEmail,
    clickBack() {
      console.log("click back");
      this.tabIndex--;
    },
    clickNext() {
      console.log("click next");
      this.tabIndex = this.tabIndex + 1;
    },
    onSubmit(e) {
      e.preventDefault();

      this.is_loading = true;

      console.log("submit register contracotr");
      console.log(this.client_name);
      console.log(
        this.first_name,
        this.last_name,
        this.email,
        this.phone_number,
        this.experience_level
      );
      console.log("Services:", this.service);
      console.log(this.rate, this.rate_amount, this.password);
      console.log(this.linkedin, this.facebook, this.website);
      console.log(":subscription:", this.subscription);
      console.log("is company:", this.is_company);
      console.log("company info:");
      console.log(
        this.legal_company_name,
        this.company_trading_name,
        this.primary_email_address
      );
      console.log(
        this.company_registration_number,
        this.vat_number,
        this.company_description
      );
      console.log("files");
      console.log(this.company_logo);
      console.log(this.images);
      console.log(this.job_reference);
      console.log("Admin", this.add_admin);
      console.log(this.admins);
      console.log("Staff", this.add_staff);
      console.log(this.staff_list);

      let is_valid = this.checkValidation();
      console.log('is_valid', is_valid)
      if (is_valid) {
        // this.sendRequests();

        //check if found user
        let formData = new FormData()
        formData.append("client", this.client_name);
        formData.append("email", this.email);
        formData.append("phone", this.phone_number);
        formData.append("user_type", "operator");

        axios
          .post("common/check/unique-email-phone", formData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name
            },
          })
          .then((response) => {
            console.log(response);
            if (response.data.user_found == 1) {
              let message = "The email/phone number has been registered before"
              this.$fire({
                // title: "Title",
                text: message,
                type: "error",
                // timer: 3000,
                customClass: {
                  container: this.swal_container_class,
                  confirmButton: this.swal_confirm_button_class,
                },
              }).then((r) => {
                // console.log(r.value);
                this.is_loading = false;
                this.tabIndex = 0
              });
            } else {
              this.sendRequests();
            }
          })
          .catch((error) => {
            console.log(error.response);
            this.is_loading = false;
            this.$fire({
              // title: "Title",
              text: error.response.data.error,
              type: "error",
              // timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
              this.is_loading = false;
            });
          });

        // the email/phone number has been registered before
        // 
      } else {
        this.is_loading = false;
      }
    },
    checkValidation() {
      console.log("check validation", this.term_conditions);
      // if (this.term_conditions == null || this.term_conditions == "" || this.term_conditions == 0) {
      //   this.invalid_term_conditions = true;
      // } else {
      //   this.invalid_term_conditions = false;
      // }

      if (this.first_name == null || this.first_name == "") {
        this.invalid_first_name = true;
      } else {
        this.invalid_first_name = false;
      }
      if (this.last_name == null || this.last_name == "") {
        this.invalid_last_name = true;
      } else {
        this.invalid_last_name = false;
      }
      if (this.email == null || this.email == "") {
        this.invalid_email = true;
      } else {
        this.invalid_email = false;
        if (this.validateEmail(this.email)) {
          this.invalid_correct_email = false;
        } else {
          this.invalid_correct_email = true;
        }
      }
      if (this.phone_number == null || this.phone_number == "") {
        this.invalid_phone_number = true;
      } else {
        this.invalid_phone_number = false;
      }

      if (this.password == null || this.password == "") {
        this.invalid_password = true;
      } else {
        this.invalid_password = false;
        if (this.validatePassword(this.password)) {
          this.invalid_correct_password = false;
        } else {
          this.invalid_correct_password = true;
        }
      }
      if (this.confirm_password == null || this.confirm_password == "") {
        this.invalid_confirm_password = true;
      } else {
        this.invalid_confirm_password = false;
        if (this.password == this.confirm_password) {
          this.invalid_correct_confirm_password = false;
        } else {
          this.invalid_correct_confirm_password = true;
        }
      }
      if (this.address == null || this.address == '') {
        this.invalid_address = true
      } else {
        this.invalid_address = false
        if (this.latitude == null || this.latitude == '') {
          this.invalid_address_latitude = true
        } else {
          this.invalid_address_latitude = false
        }
        if (this.longitude == null || this.longitude == '') {
          this.invalid_address_longitude = true
        } else {
          this.invalid_address_longitude = false
        }
      }

      // if (this.experience_level == null || this.experience_level == "") {
      //   this.invalid_experience_level = true;
      // } else {
      //   this.invalid_experience_level = false;
      // }
      // if (this.rate == null || this.rate == "") {
      //   this.invalid_rate = true;
      // } else {
      //   this.invalid_rate = false;
      // }
      // if (this.rate_amount == null || this.rate_amount == "") {
      //   this.invalid_rate_amount = true;
      // } else {
      //   this.invalid_rate_amount = false;
      // }
      // if (
      //   this.service == null ||
      //   this.service == "" ||
      //   this.service.length == 0
      // ) {
      //   this.invalid_service = true;
      // } else {
      //   this.invalid_service = false;
      // }

      // if (this.legal_company_name == null || this.legal_company_name == "") {
      //   this.invalid_legal_company_name = true;
      // } else {
      //   this.invalid_legal_company_name = false;
      // }
      // if (
      //   this.primary_email_address == null ||
      //   this.primary_email_address == ""
      // ) {
      //   this.invalid_primary_email_address = true;
      // } else {
      //   this.invalid_primary_email_address = false;
      // }
      console.log('here validation', this.invalid_primary_email_address);
      // validate admins
      this.invalid_admins = false;
      // if (this.add_admin == 1) {
      //   for (let i = 0; i < this.admins.length; i++) {
      //     let admin = this.admins[i];
      //     if (admin.name == null || admin.name == "") {
      //       this.admins[i].invalid_name = true;
      //       this.invalid_admins = true;
      //     } else {
      //       this.admins[i].invalid_name = false;
      //     }
      //     if (admin.email == null || admin.email == "") {
      //       this.admins[i].invalid_email = true;
      //       this.invalid_admins = true;
      //     } else {
      //       this.admins[i].invalid_email = false;
      //     }
      //     if (admin.phone_number == null || admin.phone_number == "") {
      //       this.admins[i].invalid_phone_number = true;
      //       this.invalid_admins = true;
      //     } else {
      //       this.admins[i].invalid_phone_number = false;
      //     }
      //   }
      // }
      // validate staff
      this.invalid_staff = false;
      if (this.add_staff == 1) {
        for (let i = 0; i < this.staff_list.length; i++) {
          let staff = this.staff_list[i];
          if (staff.first_name == null || staff.first_name == "") {
            this.staff_list[i].invalid_first_name = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_first_name = false;
          }
          if (staff.last_name == null || staff.last_name == "") {
            this.staff_list[i].invalid_last_name = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_last_name = false;
          }
          if (staff.email == null || staff.email == "") {
            this.staff_list[i].invalid_email = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_email = false;
            if (this.validateEmail(staff.email)) {
              this.staff_list[i].invalid_correct_email = false;
            } else {
              this.staff_list[i].invalid_correct_email = true;
            }
          }
          if (staff.phone == null || staff.phone == "") {
            this.staff_list[i].invalid_phone = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_phone = false;
          }
          if (staff.service == null || staff.service == "") {
            this.staff_list[i].invalid_service = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_service = false;
          }
          if (staff.experience_level == null || staff.experience_level == "") {
            this.staff_list[i].invalid_experience_level = true;
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_experience_level = false;
          }

          if (staff.address == null || staff.address == '') {
            this.staff_list[i].invalid_address = true
            this.invalid_staff = true;
          } else {
            this.staff_list[i].invalid_address = false
            if (staff.latitude == null || staff.latitude == '') {
              this.staff_list[i].invalid_address_latitude = true
              this.invalid_staff = true;
            } else {
              this.staff_list[i].invalid_address_latitude = false
            }
            if (staff.longitude == null || staff.longitude == '') {
              this.staff_list[i].invalid_address_longitude = true
              this.invalid_staff = true;
            } else {
              this.staff_list[i].invalid_address_longitude = false
            }
          }
        }
      }

      console.log("validation");
      console.log(
        this.invalid_first_name,
        this.invalid_last_name,
        this.invalid_email,
        this.invalid_correct_email,
        this.invalid_phone_number,
        this.invalid_password,
        this.invalid_correct_password,
        this.invalid_confirm_password,
        this.invalid_correct_confirm_password,
        this.invalid_experience_level,
        this.invalid_rate,
        this.invalid_rate_amount,
        this.invalid_service
      );
      console.log(`this.invalid_address: ${this.invalid_address}`, `this.invalid_address_longitude ${this.invalid_address_longitude}`, `this.invalid_address_latitude ${this.invalid_address_latitude}`)
      console.log(
        this.invalid_legal_company_name,
        this.invalid_primary_email_address
      );
      console.log(this.invalid_admins, this.admins);
      console.log(
        this.is_company == 1 && this.add_admin == 1,
        this.is_company == 1,
        this.add_admin == 1
      );

      if (
        this.invalid_first_name ||
        this.invalid_last_name ||
        this.invalid_email ||
        this.invalid_correct_email ||
        this.invalid_phone_number ||
        this.invalid_password ||
        this.invalid_correct_password ||
        this.invalid_confirm_password ||
        this.invalid_correct_confirm_password ||
        this.invalid_experience_level ||
        this.invalid_rate ||
        this.invalid_rate_amount ||
        this.invalid_address ||
        this.invalid_address_latitude ||
        this.invalid_address_longitude ||
        (this.is_company != 1 && this.invalid_service)
      ) {
        this.tabIndex = 0;
        return false;
      } else if (
        this.is_company == 1 &&
        (this.invalid_service ||
          this.invalid_legal_company_name ||
          this.invalid_primary_email_address)
      ) {
        this.tabIndex = 1;
        return false;
      } else if (
        this.is_company == 1 &&
        this.add_staff == 1 &&
        !this.invalid_staff
      ) {
        this.tabIndex = 2;
        return false;
      } 
      // else if (
      //   this.is_company == 1 &&
      //   this.add_admin == 1 &&
      //   !this.invalid_admins
      // ) {
      //   this.tabIndex = 2;
      //   return false;
      // }
      else if (this.invalid_term_conditions) {
        if (this.is_company == 1) {
          this.tabIndex = this.total_Steps - 2
        } else {
          this.tabIndex = this.total_Steps - 2
        }
        return false
      }

      return true;
    },
    async sendRequests() {

      console.log("filesssss",
        this.job_reference_ids,
        this.company_logo_id,
        this.images_ids
      );
      if (this.job_reference != null && this.job_reference.length > 0) {
        this.job_reference_ids = await this.uploadFiles(
          this.client_name,
          this.job_reference,
          null
        );
      }
      if (this.company_logo != null && this.company_logo.length > 0) {
        this.company_logo_id = await this.uploadFiles(
          this.client_name,
          this.company_logo,
          null
        );
      }
      if (this.images != null && this.images.length > 0) {
        this.images_ids = await this.uploadFiles(
          this.client_name,
          this.images,
          null
        );
      }
      console.log(
        this.job_reference_ids,
        this.company_logo_id,
        this.images_ids
      );

      this.sendSaveOperatorRequest();
    },
    sendSaveOperatorRequest() {
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("email", this.email);
      formData.append("phone", this.phone_number);
      formData.append("password", this.password);


      formData.append("address", this.address);
      formData.append("longitude", this.longitude);
      formData.append("latitude", this.latitude);
      formData.append("country", this.country);
      formData.append("county", this.county);
      formData.append("city", this.city);
      formData.append("currency", this.currency);
      formData.append("country_code", this.country_code);

      console.log("before operator/register")
      axios
        .post("operator/register", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response);
          this.operator_id = response.data.id;
          this.sendRegisterContractorRequest();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
    sendRegisterContractorRequest() {
      console.log("in send register cobtractor request");
      let requestData = {
        client: this.client_name,
        operator_id: this.operator_id,

        experience_level: this.experience_level,
        services: this.service,
        rate_type: this.rate,
        rate_amount: this.rate_amount,

        vat_no: this.vat_number,

        linkedin: this.linkedin,
        facebook: this.facebook,
        website: this.website,
      };
      if (this.company_logo_id != null) {
        requestData.company_logo_id = this.company_logo_id;
      }
      if (this.job_reference_ids != null) {
        requestData.job_reference_id = this.job_reference_ids;
      }
      if (this.images_ids != null) {
        requestData.company_images_ids = this.images_ids;
      }
      if (this.add_admin == 1) {
        requestData.admins = this.admins;
      }
      if (this.is_company == 1) {
        requestData.is_company = this.is_company
        requestData.company_legal_name = this.legal_company_name;
        requestData.company_trading_name = this.company_trading_name;
        requestData.primary_email = this.primary_email_address;
        requestData.company_reg_no = this.company_registration_number;
        requestData.company_description = this.company_description;
        requestData.business_name = this.business_name;
      }

      console.log(requestData);

      axios
        .post("operator/contractor/register", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response);
          if (this.add_staff == 1) {
            this.sendStaffDataRequest()
          } else {
            this.$fire({
              // title: "Title",
              text: "Your account has been registered successfully. \nYou can now login and start using the system ",
              type: "success",
              // timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
              this.is_loading = false;
              // this.$router.go();                        
              // this.$router.push({ name: "GardenHelpLogin", type: 'contractor' });
              this.$router.push('/garden_help/login/contractor')

            });
          }

        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    sendStaffDataRequest() {
      console.log("in send register cobtractor request");
      let requestData = {
        client: this.client_name,
        "contractor_company_id": this.operator_id,
        "staff_accounts": this.staff_list
      };

      console.log(requestData);

      axios
        .post("/operator/contractor/register-staff", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Your account has been registered successfully. \nYou can now login and start using the system ",
            type: "success",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            // this.$router.go();                        
            // this.$router.push({ name: "GardenHelpLogin", type: 'contractor' });
            this.$router.push('/garden_help/login/contractor')

          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../styles/garden-help-auth-styles.css";
@import "../styles/garden-help-styles.css";
@import "../styles/garden-help-button-styles.css";

body {
  max-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/Register.vue